module.exports = __webpack_public_path__ + "img/top7_img3.857150d2.png";